/** Dev tenant allowed to use HMRC sandbox tooling (UI visibility only; backend enforces). */
export const HMRC_SANDBOX_TOOLS_TENANT_ID = '29c06339-2549-4f52-bcf5-5573db581ca5';

/** Service keys that enrol for EORI / customs (mirrors server EORI_RELATED_SERVICE_KEYS). */
export const EORI_RELATED_SERVICE_KEYS = new Set([
  'customs-services',
  'goods-vehicle-movements',
  'import-control-system',
  'common-transit-convention-traders',
  'common-transit-convention-traders-legacy',
  'safety-and-security',
  'modernisation-of-customs-declaration-service',
]);

export const NINO_RELATED_SERVICE_KEYS = new Set(['national-insurance', 'mtd-income-tax']);

export const SERVICE_GROUP_LABELS = {
  vat: 'VAT',
  incomeTax: 'Income tax & NI',
  customs: 'Customs & trade',
  paye: 'PAYE & employment',
  agent: 'Agent services',
  other: 'Other services',
};
